import { roles } from 'commons/auth/roles';
import { ElementTypeUtils } from "./ElementTypeUtils";

export default class ElementHistory {
  /**
   * This method is used to control visibility of 'show changes' button
   */
  public static privileged(type: string, profileRoles: any) {
    if (ElementTypeUtils.isAhistorical(type)) {
      return false;
    }

    // roles
    return !!profileRoles.some((role: string) => roles.admin.includes(role) || roles.monitor.includes(role));
  }

  /**
   * Format value
   */
  public static formatValue(value: any) {
    if (!Array.isArray(value)) {
      JSON.stringify(value);
    }

    return value?.map((value: any) => (value?.value) ? value?.value : value);
  }
}
